<template>
  <div class="merchantDetails">
    <el-tabs v-model="activeName" v-if="merchantId !== ''">
      <el-tab-pane label="商户详情" name="info"></el-tab-pane>
      <el-tab-pane label="费率信息" name="rate"></el-tab-pane>

      <info-form
        v-show="activeName === 'info'"
        :read-only="readOnly"
        :is-edit="isEdit"
        :id="merchantId"
        :submit-loading="buttonLoading"
        @submit="editInfo"
        @resetDisabled="readOnly = true"></info-form>
      <rate-form v-show="activeName === 'rate'" v-if="hasGetRate" :read-only="readOnly" :is-edit="isEdit" :id="merchantId"></rate-form>

    </el-tabs>
  </div>
</template>

<script>
import infoForm from '../components/infoForm1'
import rateForm from '../components/rateForm'
import { updateIntellectMerchant } from '@/api/merchant'
import qs from 'qs'
import md5 from 'js-md5'
export default {
  name: 'MerchantDetails',
  components: {
    infoForm,
    rateForm
  },
  data () {
    return {
      activeName: 'info',
      buttonLoading: false, // 按钮加载中
      readOnly: '',
      isEdit: '',
      merchantId: '', // 商户id
      hasGetRate: false // 是否已加载费率信息
    }
  },
  watch: {
    activeName (val) {
      if (val === 'rate' && !this.hasGetRate) {
        this.hasGetRate = true
      }
    }
  },
  created () {
    console.log('activated:', this.$route.query)
    if (JSON.stringify(this.$route.query) !== '{}') {
      const query = this.$route.query
      if (this.merchantId !== query.id) {
        this.merchantId = query.id
        this.readOnly = query.readOnly === '1'
        this.isEdit = query.isEdit === '1'
        localStorage.setItem('merchantDetailsQuery', JSON.stringify(query))
      }
    } else {
      if (localStorage.getItem('merchantDetailsQuery') !== '') {
        const query = JSON.parse(localStorage.getItem('merchantDetailsQuery'))
        this.merchantId = query.id
        this.readOnly = query.readOnly === '1'
        this.isEdit = query.isEdit === '1'
      }
    }
    if (this.activeName === 'info') {
      this.hasGetRate = false
    }
  },
  methods: {
    /**
             * @description 编辑商户信息
             * @param  {number} data 组件提交的数据
             */
    editInfo (data) {
      let param = JSON.parse(JSON.stringify(data))
      const that = this
      const pw = param.userPassword
      if (pw) {
        param.userPassword = md5(pw)
      }
      param = Object.assign({}, param, { merchantId: that.merchantId })
      // 删除不需提交的参数
      delete param.headShopMerchantId
      delete param.username
      delete param.statusDesc
      delete param.reportConfigId
      // delete param.credentialType;

      that.$confirm('确认提交吗？', '提示', {}).then(() => {
        that.buttonLoading = true
        param = qs.stringify(this.dismissBlank(param))
        updateIntellectMerchant(param).then(data => {
          that.buttonLoading = false
          if (data.result_cde === '0') {
            that.$message({
              message: data.result_msg,
              type: 'success'
            })
            that.$router.push({ path: '/Merchant/MerchantManage/AllMerchant' })
          } else {
            that.$message({
              showClose: true,
              message: data.result_msg,
              type: 'error'
            })
          }
        })
      })
    },
    /**
             * @description 删除对象中字符串的空格
             * @param  {number} params 目标对象
             */
    dismissBlank (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !['legalName', 'holder'].includes(key)) {
          const element = params[key]
          if (typeof element === 'string') {
            params[key] = element.replace(/ /g, '')
          }
        }
      }
      console.log(params)
      return params
    }
  }
}
</script>

<style scoped>
    .merchantDetails {
        padding: 20px
    }
</style>
<style>
    .merchantDetails .el-tabs__item{
        font-size: 18px;
    }
</style>
